//
// Accordion component
//

import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/common/utils/platform/trackEvent';

function accordion() {
    this.attributes({
        accordionHeaderSelector: '[data-accordion-header]',
        accordionBodySelector: '[data-accordion-body]',
    });

    this.after('initialize', function () {
        this.on('click', {
            accordionHeaderSelector: this.toggleAccordion,
        });

        if (!this.isCollapsed()) {
            this.select('accordionBodySelector').show();
        }
    });

    this.toggleAccordion = function () {
        if (this.isCollapsed()) {
            this.$node.removeAttr('data-accordion-collapse');
            this.openAccordion();
        } else {
            this.$node.attr('data-accordion-collapse', true);
            this.closeAccordion();
        }

        if (this.hasTrackEventName()) {
            if (this.hasTrackEventParams()) {
                trackEvent(
                    this.$node.attr('data-accordion-track-event-name'),
                    JSON.parse(this.$node.attr('data-accordion-track-event-params'))
                );
            } else {
                trackEvent(this.$node.attr('data-accordion-track-event-name'));
            }
        }
    };

    this.isCollapsed = function () {
        return this.$node[0].hasAttribute('data-accordion-collapse');
    };

    this.hasTrackEventName = function () {
        return this.$node[0].hasAttribute('data-accordion-track-event-name');
    };

    this.hasTrackEventParams = function () {
        return this.$node[0].hasAttribute('data-accordion-track-event-params');
    };

    this.openAccordion = function () {
        this.select('accordionBodySelector').slideDown();
    };

    this.closeAccordion = function () {
        this.select('accordionBodySelector').slideUp();
    };
}

export default defineComponent(accordion);



// WEBPACK FOOTER //
// ./src/web/js/app/ui/accordion.js